import { Mask } from '@kds/kid-ui-plus';
import React from 'react';
import { useAutoSetWidth } from '@/component/SeoContainer';

interface Props {
    visible: boolean;
    onClose: () => void;
    children: React.ReactNode;
}
export function FixedBottomPanel(props: Props) {
    const { visible, onClose, children } = props;

    const { width } = useAutoSetWidth();
    return visible ? (
        <div
            onClick={onClose}
            style={{"zIndex":99,"backgroundColor":"rgba(0, 0, 0, 0.3)","position":"fixed","top":"0rem","left":"0rem","right":"0rem","bottom":"0rem"}}>
            <div
                style={{"position":"fixed","bottom":"0rem","left":"0rem","right":"0rem","zIndex":100,"display":"flex","justifyContent":"center"}}>
                <div
                    style={{
                        width: width,
                        backgroundColor: '#fff',
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        paddingBottom: 20,
                    }}>
                    {children}
                </div>
            </div>
        </div>
    ) : null;
}
